import { useIsNationalLibrary } from "./useIsNationalLibrary";
export var useCanRequestCopies = function () {
    var _a = useIsNationalLibrary(), canRequestCopies = _a.canRequestCopies, isLoading = _a.isLoading;
    return { canRequestCopies: canRequestCopies, isLoading: isLoading };
};
